<template>
  <div>
    <main class="home-page">
    <section class="device-card">
      <div class="device-head">
        <img class="avatar" src="./static/images/home-avatar.png" alt="头像">
        <div>
          <h1>
            <button class="device-no-btn" type="button" @click="onCopySuccess">
              <span>设备号：{{ operator.short_number || iccid }}</span>
              <span class="copy-icon" aria-hidden="true"></span>
            </button>
          </h1>
          <p>{{ expireDate ? expireDate.replace(/\//g,'-') : '--/--/--' }}到期</p>
        </div>
      </div>
      <div class="status-row" v-if="operator.system === 'SHUANGKAONE'">
        <div class="status-box" v-for="item in shuangkaList" :key="item.type">
          <p>{{ operatorType[item.type] }}状态：<span :class="{ 'status-value--danger': isDangerStatus(item.statusName) }">{{ item.statusName || "查询中" }}</span></p>
          <p>{{ operatorType[item.type] }}实名：<span :class="{ 'status-value--danger': item.auth !== 1 }">{{ item.auth === 1 ? "已实名" : "未实名" }}</span></p>
        </div>
      </div>
      <div class="status-row" v-else>
        <div class="status-box">
          <p>卡状态：<span :class="{ 'status-value--danger': isDangerStatus(simStatusName) }">{{ simStatusName }}</span></p>
          <p>实名：<span :class="{ 'status-value--danger': simAuthStatus !== 1 }">{{ simAuthStatusName }}</span></p>
        </div>
      </div>
      <div class="flow-row">
        <div class="flow-box"><p>{{ usedUsage }}G</p><p>已用流量</p></div>
        <button type="button" @click="$router.push({name:'bind',query:{nostorage:1}})">更换卡号</button>
      </div>
    </section>

    <section class="panel">
      <h2>流量套餐</h2>
      <div class="menu three-cols">
        <div class="menu-item" @click="handleRechargeBtnClick"><img class="service-icon" src="./static/images/image/home-goumaitaocan.png" alt=""><span>购买套餐</span></div>
        <div class="menu-item" @click="$router.push({name:'order',query:{iccid:iccid}})"><img class="service-icon" src="./static/images/image/home-chongzhijilu.png" alt=""><span>充值记录</span></div>
        <div class="menu-item" @click="$router.push({name:'usage',query:{iccid:iccid}})"><img class="service-icon" src="./static/images/image/home-liuliangchaxun.png" alt=""><span>流量查询</span></div>
      </div>
    </section>

    <section class="panel">
      <h2>我的服务</h2>
      <div class="menu service-grid">
        <div class="menu-item" @click="flushPage"><img class="service-icon" src="./static/images/image/home-shuaxinwangluo.png" alt=""><span>刷新网络</span></div>
        <div class="menu-item" @click="checkCard"><img class="service-icon" src="./static/images/image/home-zhenduan.png" alt=""><span>诊断</span></div>
        <a class="menu-item menu-item-link" :href="customerUrl || 'javascript:;'"><img class="service-icon" src="./static/images/image/home-kefu.png" alt=""><span>客服</span></a>
        <div class="menu-item" @click="handleRealnameClick"><img class="service-icon" src="./static/images/image/home-shiming.png" alt=""><span>实名</span></div>
        <div
          class="menu-item"
          v-if="showChinaMobileSecondRealname"
          @click="handleChinaMobileRealnameClick"
        >
          <img class="service-icon" src="./static/images/image/home-shiming.png" alt=""><span>移动二次认证</span>
        </div>
        <!--<div class="menu-item" @click="$router.push({name:'shengji',query:{iccid:iccid}})"><img class="service-icon" src="./static/images/image/home-taocanshengji.png" alt=""><span>套餐升级</span></div>-->
        <div class="menu-item" @click="$router.push({name:'device',query:{iccid:operator.short_number||iccid}})"><img class="service-icon" src="./static/images/image/home-shebeiguanli.png" alt=""><span>设备管理</span></div>
        <div class="menu-item" @click="$router.push({name:'follow',query:{iccid:operator.short_number||iccid}})"><img class="service-icon" src="./static/images/image/home-gongzhonghao.png" alt=""><span>公众号</span></div>
        <div class="menu-item" @click="$router.push({name:'feedback',query:{iccid:operator.short_number||iccid}})"><img class="service-icon" src="./static/images/image/home-guanfangtousu.png" alt=""><span>官方投诉</span></div>
        <div class="menu-item" @click="$router.push({name:'bind',query:{nostorage:1}})"><img class="service-icon" src="./static/images/image/home-tuichudenglu.png" alt=""><span>退出登录</span></div>
      </div>
    </section>

    </main>
    <div class="mask" v-if="showRealnameModal" @click.self="closeRealnameModal">
      <div class="realname-sheet">
        <div class="sheet-head">
          <p>设备实名才可以使用</p>
          <button type="button" aria-label="关闭" @click="closeRealnameModal">×</button>
        </div>
        <div class="realname-grid">
          <div
            class="realname-card"
            :class="{ 'realname-card--clickable': item.auth !== 1 }"
            v-for="item in realnameCards"
            :key="item.type"
            @click="handleRealnameCardClick(item)"
          >
            <h3>{{ operatorType[item.type] }}实名</h3>
            <span :class="{ 'status-value--danger': item.auth !== 1 }">{{ item.auth === 1 ? "已实名" : "未实名" }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5"

export default {
  name: "indexNew",
  data () {
    return {
      wxReady: false,
      iccid: "",
      customerUrl: "",
      cardlist: [],
      packageList: [],
      totalUsage: 0,
      usedUsage: 0,
      remainUsage: 0,
      expireDate: "",
      simStatusName: "未知状态",
      simAuthStatus: 0,
      shuangka: {
        liantong: {},
        dianxin: {},
        yidong: {}
      },
      operatorType: {
        liantong: "联通",
        dianxin: "电信",
        yidong: "移动"
      },
      operator: { authUrl: "" }
      ,
      showRealnameModal: false
    }
  },
  computed: {
    simAuthStatusName () {
      if (this.operator.activeRule === 2 && this.simAuthStatus === 0 && this.totalUsage === 0) return "请先续费"
      return this.simAuthStatus === 1 ? "已实名" : "未实名"
    },
    shuangkaList () {
      return Object.keys(this.shuangka)
        .filter((type) => this.shuangka[type] && this.shuangka[type].iccid)
        .map((type) => ({
          type,
          ...this.shuangka[type]
        }))
    },
    realnameCards () {
      if (this.operator.system !== "SHUANGKAONE") {
        return [{
          type: "dianxin",
          auth: this.simAuthStatus,
          authUrl: this.operator.authUrl
        }]
      }
      const nt = this.operator.netType
      const matchNetType = (type) => {
        if (nt === 0 || nt == null) return true
        if (type === "dianxin") return nt === 2 || nt === 5 || nt === 6
        if (type === "liantong") return nt === 3 || nt === 5 || nt === 7
        if (type === "yidong") return nt === 4 || nt === 6 || nt === 7
        return false
      }
      const order = ["dianxin", "yidong", "liantong"]
      return order
        .filter((type) => {
          const card = this.shuangka[type]
          return card && card.iccid && matchNetType(type)
        })
        .map((type) => ({
          type,
          ...this.shuangka[type]
        }))
    },
    mobileIccidFromShuangka () {
      return (this.shuangka && this.shuangka.yidong && this.shuangka.yidong.iccid) ? this.shuangka.yidong.iccid : ""
    },
    showChinaMobileSecondRealname () {
      const isShuangkaDevice = this.operator && this.operator.system === "SHUANGKAONE"
      const iccid = this.mobileIccidFromShuangka
      return isShuangkaDevice && iccid && ("" + iccid).startsWith("8986")
    }
  },
  watch: {
    iccid () {
      sessionStorage.setItem("iccid", this.iccid)
      this.queryPackageList()
      this.queryOperatorInfo()
      this.queryCardStatus()
    }
  },
  methods: {
    isDangerStatus (statusName) {
      const allowSet = new Set(["正常", "在用", "已激活", "可激活"])
      const name = ((statusName || "") + "").trim()
      return !allowSet.has(name)
    },
    checkCard () {
      this.$toast.loading("诊断中")
      this.fetchData("/card/check", { iccid: this.iccid }, (res) => { this.$toast.clear(); this.$toast(res.msg) })
    },
    flushPage () {
      this.$toast.loading("网络重置中")
      setTimeout(() => { this.$toast.clear(); this.$toast("重置成功，请10分钟后重启设备") }, 2000)
    },
    handleCopyIccid () {
      if (this.operator.authUrl) window.location.href = this.operator.authUrl
      else this.$toast.fail("未配置实名网址，请刷新或联系客服")
    },
    handleRealnameClick () {
      this.showRealnameModal = true
    },
    closeRealnameModal () {
      this.showRealnameModal = false
    },
    handleRealnameCardClick (item) {
      if (!item || item.auth === 1) return
      const card = this.shuangka[item.type] || {}
      const authUrl = item.authUrl || card.authUrl || this.operator.authUrl
      if (!authUrl) return this.$toast.fail("未配置实名网址，请刷新后重试")
      window.location.href = authUrl
    },
    chinaMobileAuthMacPairFromIccid (iccidValue) {
      const hex = md5(String(iccidValue).trim())
      const hex12ToMac = (h12) => h12.match(/.{2}/g).map((p) => p.toUpperCase()).join("-")
      return {
        terminalMac: hex12ToMac(hex.slice(0, 12)),
        mac: hex12ToMac(hex.slice(-12))
      }
    },
    handleChinaMobileRealnameClick () {
      const iccidValue = this.mobileIccidFromShuangka
      if (!iccidValue) return this.$toast.fail("未获取到移动ICCID，请刷新后重试")
      const { terminalMac, mac } = this.chinaMobileAuthMacPairFromIccid(iccidValue)
      const iccid = encodeURIComponent(iccidValue)
      const url = `https://wireless.cmonelink.com/wirelessAuthentication/authentication?terminalMac=${encodeURIComponent(terminalMac)}&mac=${encodeURIComponent(mac)}&iccid=${iccid}`
      window.location.href = url
    },
    onCopySuccess () {
      const text = this.operator.short_number || this.iccid
      const input = document.createElement("input")
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      document.body.removeChild(input)
      this.$toast.success("复制成功")
    },
    rechargeDeviceQuery () {
      const dev = this.operator.short_number || this.iccid
      return { iccid: dev }
    },
    handleRechargeBtnClick () {
      const q = this.rechargeDeviceQuery()
      if (this.operator.rechargeType < 2) this.$router.push({ name: "recharge", query: q })
      else this.$router.push({ name: "rechargeBalance", query: { ...q, remainUsage: this.remainUsage } })
    },
    queryOperatorInfo () {
      this.fetchData("/card/cardOperator", { iccid: this.iccid }, (res) => { if (res.code) this.operator = res.data })
    },
    queryUserCards () {
      this.fetchData("/card/querylist", {}, (res) => {
        if (!res.code) return this.$router.push({ name: "bind" })
        for (const card of res.data) {
          this.cardlist.push({ name: card.iccid, value: card.iccid })
          if (card.default === 1 && !this.iccid) this.iccid = card.iccid
        }
      })
    },
    queryPackageList () {
      this.fetchData("/package/monthlist", { iccid: this.iccid }, (res) => { if (res.code) this.packageList = res.data })
    },
    queryCardStatus () {
      this.$toast.loading({ message: "加载中", duration: 50000 })
      this.fetchData("/card/status", { iccid: this.iccid }, (res) => {
        this.$toast.clear()
        if (!res.code) return this.$toast.fail(res.msg)
        this.simStatusName = res.data.simStatusName || this.simStatusName
        this.simAuthStatus = res.data.simAuthStatus
        this.totalUsage = res.data.total
        this.remainUsage = res.data.remain
        this.usedUsage = res.data.used
        this.expireDate = res.data.expire
        if (res.data.data && res.data.data.shuangka) {
          this.shuangka = res.data.data.shuangka
          if (!this.totalUsage) {
            this.$dialog.confirm({
              title: "温馨提示",
              message: "当前设备无套餐，请先充值"
            }).then(() => {
              this.handleRechargeBtnClick()
            }).catch(() => {})
          }
          Object.keys(this.shuangka).forEach((type) => {
            const card = this.shuangka[type]
            if (!card || !card.iccid) return
            this.$set(this.shuangka[type], "statusName", card.statusName || "查询中")
            this.$set(this.shuangka[type], "auth", card.auth || 0)
            this.fetchData("/card/status", { iccid: card.iccid }, (subRes) => {
              if (subRes && subRes.code && subRes.data) {
                this.$set(this.shuangka[type], "statusName", subRes.data.simStatusName || "未知状态")
                this.$set(this.shuangka[type], "auth", subRes.data.simAuthStatus)
              }
            })
          })
        }
      })
    }
  },
  created () {
    const routeIccid = this.$route.query.iccid
    if (routeIccid) this.iccid = routeIccid
    this.queryUserCards()
    this.fetchData("/config/customerUrl", {}, (res) => { if (res.data) this.customerUrl = res.data })
  }
}
</script>

<style scoped src="./static/css/home.css"></style>
<style scoped>
.home-page {
  --bg: #e9e9e9;
  --card: #f7f7f7;
  --blue-1: #3768d9;
  --blue-2: #624cdb;
  --green: #22bb74;
  --text: #161616;
  background: var(--bg);
}

.menu-item-link {
  text-decoration: none;
  color: inherit;
}

.menu-item-link:visited,
.menu-item-link:hover,
.menu-item-link:active {
  color: inherit;
  text-decoration: none;
}

.device-no-btn {
  display: inline-flex;
  align-items: center;
  gap: .06rem;
}

.copy-icon {
  position: relative;
  width: .14rem;
  height: .14rem;
  border: 1px solid rgba(255, 255, 255, .95);
  border-radius: .02rem;
}

.copy-icon::before {
  content: "";
  position: absolute;
  left: .03rem;
  top: -.04rem;
  width: .14rem;
  height: .14rem;
  border: 1px solid rgba(255, 255, 255, .95);
  border-radius: .02rem;
  background: transparent;
}

.status-value--danger {
  color: #ff4d4f !important;
}

.realname-card--clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/newpage/index.vue